// ThankyouPage.tsx
import styles from "./styles.module.scss";
import appStore from "./assets/appstore.png";
// import playStore from "./assets/playstore.png";
import loginScreen from "./assets/login.png";
import loginScreenWalky from "./assets/loginWalky.png";
import welcomeScreen from "./assets/image.png";
import welcomeScreenWalky from "./assets/imageWalky.png";
import { Button } from "@common/button";
import { OnboardingLayout } from "@common/onboardingLayout";
import { ProfileLayout } from "../profile/layout";
import { WalkyLayout } from "../profile/walkyLayout";

const APP_STORE_URL = "";

export const WalkyProfile = () => {
  const handleDownload = () => {
    window.open(APP_STORE_URL);
  };

  return (
    <WalkyLayout>
      <div className={`${styles.versionContainer} ${styles.walkyTheme}`}>
        <p className={styles.subtitle}>You can download the app</p>

        <div className={styles.step}>
          <div className={styles.stepNumber}>1</div>
          <p>
            <span>Download</span> the app using the link below
          </p>
          <a href={APP_STORE_URL} className={styles.appStoreButton}>
            <img src={appStore} alt="Download on the App Store" />
          </a>
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>2</div>
          <p>
            Tap "<span>Already have an account? </span>
            <span className={styles.link}> Log in</span>"
          </p>
          <img
            src={welcomeScreenWalky}
            alt="Login screen"
            className={styles.screenImageArrow}
          />
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>3</div>
          <p>
            Enter your <span>email</span> & <span>get the code</span>
          </p>
          <img
            src={loginScreenWalky}
            alt="Auth screen"
            className={styles.screenImage}
          />
        </div>
      </div>
    </WalkyLayout>
  );
};
